import { render, staticRenderFns } from "./ConversationListItem.vue?vue&type=template&id=43b20e0b&scoped=true&"
import script from "./ConversationListItem.vue?vue&type=script&lang=js&"
export * from "./ConversationListItem.vue?vue&type=script&lang=js&"
import style0 from "./ConversationListItem.vue?vue&type=style&index=0&id=43b20e0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b20e0b",
  null
  
)

export default component.exports